module.exports = __webpack_public_path__ + "img/productRobot_26.2da941f3.png";